import { USER_TYPE, USER_TOKEN, USER_DETAILS, USER_ROLES, USER_SUBSCRIPTION, CURRENT_APP } from "../Constant"

const user = (state = {}, action) => {
    switch (action.type) {
        case USER_TYPE:
            return {
                ...state,
                userType: action.payload
            }
        case CURRENT_APP: 
            return {
                ...state,
                appName: action.payload
            }
        case USER_SUBSCRIPTION:
            return {
                ...state,
                subscriptionDetails: action.payload
            }
        case USER_TOKEN:
            return {
                ...state,
                token: action.payload,
                authenticated: sessionStorage.getItem('accessToken') ? true : false
            }
        case USER_DETAILS:
            return {
                ...state,
                userDetails: action.payload
            }
        case USER_ROLES:
            return {
                ...state,
                userRoles: action.payload
            }
        default: {
            return state;
        }
    }
}

export default user;